import axios from 'axios';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import PitcherTable from '../../../components/table/PitcherTable';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from '../../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import FuturesPitcherTableWrapper from '../../../components/table/FuturesPitcherTableWrapper';
import columnConverter from '../../../utils/column/columnConverter';

function SituationFuturesPitcherRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [situationRecord, setSituationRecord] = useState([]);

    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();

    useEffect(() => {
        let {playerId} = profile;

        let batterTypePromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherBatterTypeRecord',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let opponentTeamPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherBatterTeamRecord',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let homeOrArayPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherHomeOrAwayRecord',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        })

        let monthPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherMonthRecord',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        })

        Promise.all([
            batterTypePromise, opponentTeamPromise,
            homeOrArayPromise,
            monthPromise
        ]).then((result) => {
            let tmpObj = {};
            tmpObj['batterType'] = result[0]['data']['result'];
            tmpObj['oppTeam'] = _.map(result[1]['data']['result'], (item) => {
                item['type'] = columnConverter(item['batterTeam']);
                return item;
            });

            tmpObj['homeOrAway'] = _.map(result[2]['data']['result'], (item) => {
                item['type'] = columnConverter(item['groupingType']);

                return item;
            });

            tmpObj['month'] = _.map(result[3]['data']['result'], (item) => {
                item['type'] = item['groupingType'];
                return item;
            });

            setSituationRecord(tmpObj);
            setLoading(true);
        })
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setLoading(false);
        setSeason(value);
    }

    return (
        <>
        <div style={{position:'absolute', top: '-40px', right: '10px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        {
            !loading ?
            <div style={{height: '1000px'}}><DefaultLoader /></div> :
            <>
            <TableWrapper title={t('platoonSplits2')+'-'+season}>
                <PitcherTable data={situationRecord['batterType']} column={'futuresBatterType'} />
            </TableWrapper>
            <FuturesPitcherTableWrapper title={t('pitchCount')+'-'+season} column={'futuresCount'} profile={profile} season={season}/>
            <TableWrapper title={t('homeoraway')+'-'+season}>
                <PitcherTable data={situationRecord['homeOrAway']} column={'futuresHomeOrAway'} />
            </TableWrapper>
            <TableWrapper title={t('opponent')+'-'+season}>
                <PitcherTable data={situationRecord['oppTeam']} column={'futuresOppTeam'} />
            </TableWrapper>
            <TableWrapper title={t('byMonth')+'-'+season}>
                <PitcherTable data={situationRecord['month']} column={'futuresMonth'} />
            </TableWrapper>
            </>
        }
        </>
    )
}

export default SituationFuturesPitcherRecord;